import styled from 'styled-components'

export const Container = styled.div`
  h1 {
    color: ${props => props.theme.title.primary};
  }

  text-align: center;
`
